import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/offer';

const namespace = 'OFFER';

export const SEARCH_PARAM_RESET = `${namespace}/SEARCH_PARAM_RESET`;

export const resetSearchParam = () => ({
  type: SEARCH_PARAM_RESET,
});

export const SEARCH_PARAM_SET = `${namespace}/SEARCH_PARAM_SET`;

export const setSearchParam = searchParamID => ({
  type: SEARCH_PARAM_SET,
  searchParamID,
});

export const SEARCH_PARAM_FETCH_START = `${namespace}/SEARCH_PARAM_FETCH_START`;
export const SEARCH_PARAM_FETCH_SUCCESS = `${namespace}/SEARCH_PARAM_FETCH_SUCCESS`;
export const SEARCH_PARAM_FETCH_ERROR = `${namespace}/SEARCH_PARAM_FETCH_ERROR`;

export const fetchSearchParam = makeApiActionCreatorV3(
  api.fetchSearchParam,
  SEARCH_PARAM_FETCH_START,
  SEARCH_PARAM_FETCH_SUCCESS,
  SEARCH_PARAM_FETCH_ERROR,
);

export const SEARCH_PARAMS_FETCH_START = `${namespace}/SEARCH_PARAMS_FETCH_START`;
export const SEARCH_PARAMS_FETCH_SUCCESS = `${namespace}/SEARCH_PARAMS_FETCH_SUCCESS`;
export const SEARCH_PARAMS_FETCH_ERROR = `${namespace}/SEARCH_PARAMS_FETCH_ERROR`;

export const fetchSearchParams = makeApiActionCreatorV3(
  api.fetchSearchParams,
  SEARCH_PARAMS_FETCH_START,
  SEARCH_PARAMS_FETCH_SUCCESS,
  SEARCH_PARAMS_FETCH_ERROR,
);

export const SEARCH_PARAM_INSERT_START = `${namespace}/SEARCH_PARAM_INSERT_START`;
export const SEARCH_PARAM_INSERT_SUCCESS = `${namespace}/SEARCH_PARAM_INSERT_SUCCESS`;
export const SEARCH_PARAM_INSERT_ERROR = `${namespace}/SEARCH_PARAM_INSERT_ERROR`;

export const insertSearchParam = makeApiActionCreatorV3(
  api.insertSearchParam,
  SEARCH_PARAM_INSERT_START,
  SEARCH_PARAM_INSERT_SUCCESS,
  SEARCH_PARAM_INSERT_ERROR,
);

export const SEARCH_PARAM_UPDATE_START = `${namespace}/SEARCH_PARAM_UPDATE_START`;
export const SEARCH_PARAM_UPDATE_SUCCESS = `${namespace}/SEARCH_PARAM_UPDATE_SUCCESS`;
export const SEARCH_PARAM_UPDATE_ERROR = `${namespace}/SEARCH_PARAM_UPDATE_ERROR`;

export const updateSearchParam = makeApiActionCreatorV3(
  api.updateSearchParam,
  SEARCH_PARAM_UPDATE_START,
  SEARCH_PARAM_UPDATE_SUCCESS,
  SEARCH_PARAM_UPDATE_ERROR,
);

export const SEARCH_PARAM_DUPLICATE_START = `${namespace}/SEARCH_PARAM_DUPLICATE_START`;
export const SEARCH_PARAM_DUPLICATE_SUCCESS = `${namespace}/SEARCH_PARAM_DUPLICATE_SUCCESS`;
export const SEARCH_PARAM_DUPLICATE_ERROR = `${namespace}/SEARCH_PARAM_DUPLICATE_ERROR`;

export const duplicateSearchParam = makeApiActionCreatorV3(
  api.duplicateSearchParam,
  SEARCH_PARAM_DUPLICATE_START,
  SEARCH_PARAM_DUPLICATE_SUCCESS,
  SEARCH_PARAM_DUPLICATE_ERROR,
);

export const SEARCH_PARAM_DELETE_START = `${namespace}/SEARCH_PARAM_DELETE_START`;
export const SEARCH_PARAM_DELETE_SUCCESS = `${namespace}/SEARCH_PARAM_DELETE_SUCCESS`;
export const SEARCH_PARAM_DELETE_ERROR = `${namespace}/SEARCH_PARAM_DELETE_ERROR`;

export const deleteSearchParam = makeApiActionCreatorV3(
  api.deleteSearchParam,
  SEARCH_PARAM_DELETE_START,
  SEARCH_PARAM_DELETE_SUCCESS,
  SEARCH_PARAM_DELETE_ERROR,
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const GET_CASE_FILES_START = `${namespace}/GET_CASE_FILES_START`;
export const GET_CASE_FILES_SUCCESS = `${namespace}/GET_CASE_FILES_SUCCESS`;
export const GET_CASE_FILES_ERROR = `${namespace}/GET_CASE_FILES_ERROR`;

export const getCaseFiles = makeApiActionCreatorV3(
  api.getCaseFiles,
  GET_CASE_FILES_START,
  GET_CASE_FILES_SUCCESS,
  GET_CASE_FILES_ERROR,
);

export const ADD_PROP_OFFER_FILE_START = `${namespace}/ADD_PROP_OFFER_FILE_START`;
export const ADD_PROP_OFFER_FILE_SUCCESS = `${namespace}/ADD_PROP_OFFER_FILE_SUCCESS`;
export const ADD_PROP_OFFER_FILE_ERROR = `${namespace}/ADD_PROP_OFFER_FILE_ERROR`;

export const addPropOfferFile = makeApiActionCreatorV3(
  api.addPropOfferFile,
  ADD_PROP_OFFER_FILE_START,
  ADD_PROP_OFFER_FILE_SUCCESS,
  ADD_PROP_OFFER_FILE_ERROR,
);

export const UPDATE_PROP_OFFER_FILE_START = `${namespace}/UPDATE_PROP_OFFER_FILE_START`;
export const UPDATE_PROP_OFFER_FILE_SUCCESS = `${namespace}/UPDATE_PROP_OFFER_FILE_SUCCESS`;
export const UPDATE_PROP_OFFER_FILE_ERROR = `${namespace}/UPDATE_PROP_OFFER_FILE_ERROR`;

export const updatePropOfferFile = makeApiActionCreatorV3(
  api.updatePropOfferFile,
  UPDATE_PROP_OFFER_FILE_START,
  UPDATE_PROP_OFFER_FILE_SUCCESS,
  UPDATE_PROP_OFFER_FILE_ERROR,
);

export const DELETE_PROP_OFFER_FILE_START = `${namespace}/DELETE_PROP_OFFER_FILE_START`;
export const DELETE_PROP_OFFER_FILE_SUCCESS = `${namespace}/DELETE_PROP_OFFER_FILE_SUCCESS`;
export const DELETE_PROP_OFFER_FILE_ERROR = `${namespace}/DELETE_PROP_OFFER_FILE_ERROR`;

export const deletePropOfferFile = makeApiActionCreatorV3(
  api.deletePropOfferFile,
  DELETE_PROP_OFFER_FILE_START,
  DELETE_PROP_OFFER_FILE_SUCCESS,
  DELETE_PROP_OFFER_FILE_ERROR,
);

export const DOWNLOAD_PROP_OFFER_FILE_START = `${namespace}/DOWNLOAD_PROP_OFFER_FILE_START`;
export const DOWNLOAD_PROP_OFFER_FILE_SUCCESS = `${namespace}/DOWNLOAD_PROP_OFFER_FILE_SUCCESS`;
export const DOWNLOAD_PROP_OFFER_FILE_ERROR = `${namespace}/DOWNLOAD_PROP_OFFER_FILE_ERROR`;

export const downloadPropOfferFile = makeApiActionCreatorV3(
  api.downloadPropOfferFile,
  DOWNLOAD_PROP_OFFER_FILE_START,
  DOWNLOAD_PROP_OFFER_FILE_SUCCESS,
  DOWNLOAD_PROP_OFFER_FILE_ERROR,
);

export const FETCH_PROPERTY_OFFERS_START = `${namespace}/FETCH_PROPERTY_OFFERS_START`;
export const FETCH_PROPERTY_OFFERS_SUCCESS = `${namespace}/FETCH_PROPERTY_OFFERS_SUCCESS`;
export const FETCH_PROPERTY_OFFERS_ERROR = `${namespace}/FETCH_PROPERTY_OFFERS_ERROR`;

export const fetchPropertyOffers = makeApiActionCreatorV3(
  api.fetchPropertyOffers,
  FETCH_PROPERTY_OFFERS_START,
  FETCH_PROPERTY_OFFERS_SUCCESS,
  FETCH_PROPERTY_OFFERS_ERROR,
);

export const FETCH_PROPERTY_OFFER_START = `${namespace}/FETCH_PROPERTY_OFFER_START`;
export const FETCH_PROPERTY_OFFER_SUCCESS = `${namespace}/FETCH_PROPERTY_OFFER_SUCCESS`;
export const FETCH_PROPERTY_OFFER_ERROR = `${namespace}/FETCH_PROPERTY_OFFER_ERROR`;

export const fetchPropertyOffer = makeApiActionCreatorV3(
  api.fetchPropertyOffer,
  FETCH_PROPERTY_OFFER_START,
  FETCH_PROPERTY_OFFER_SUCCESS,
  FETCH_PROPERTY_OFFER_ERROR,
);

export const FETCH_CAN_FINALIZE_START = `${namespace}/FETCH_CAN_FINALIZE_START`;
export const FETCH_CAN_FINALIZE_SUCCESS = `${namespace}/FETCH_CAN_FINALIZE_SUCCESS`;
export const FETCH_CAN_FINALIZE_ERROR = `${namespace}/FETCH_CAN_FINALIZE_ERROR`;

export const fetchCanFinalize = makeApiActionCreatorV3(
  api.fetchCanFinalize,
  FETCH_CAN_FINALIZE_START,
  FETCH_CAN_FINALIZE_SUCCESS,
  FETCH_CAN_FINALIZE_ERROR,
);

export const FETCH_PROPERTY_OFFERS_ALL_START = `${namespace}/FETCH_PROPERTY_OFFERS_ALL_START`;
export const FETCH_PROPERTY_OFFERS_ALL_SUCCESS = `${namespace}/FETCH_PROPERTY_OFFERS_ALL_SUCCESS`;
export const FETCH_PROPERTY_OFFERS_ALL_ERROR = `${namespace}/FETCH_PROPERTY_OFFERS_ALL_ERROR`;

export const fetchPropertyOffersAll = makeApiActionCreatorV3(
  api.fetchPropertyOffersAll,
  FETCH_PROPERTY_OFFERS_ALL_START,
  FETCH_PROPERTY_OFFERS_ALL_SUCCESS,
  FETCH_PROPERTY_OFFERS_ALL_ERROR,
);

export const CREATE_PROPERTY_OFFER_IND_START = `${namespace}/CREATE_PROPERTY_OFFER_IND_START`;
export const CREATE_PROPERTY_OFFER_IND_SUCCESS = `${namespace}/CREATE_PROPERTY_OFFER_IND_SUCCESS`;
export const CREATE_PROPERTY_OFFER_IND_ERROR = `${namespace}/CREATE_PROPERTY_OFFER_IND_ERROR`;

export const createPropertyOfferInd = makeApiActionCreatorV3(
  api.createPropertyOfferInd,
  CREATE_PROPERTY_OFFER_IND_START,
  CREATE_PROPERTY_OFFER_IND_SUCCESS,
  CREATE_PROPERTY_OFFER_IND_ERROR,
);

export const CREATE_PROPERTY_OFFER_AGG_START = `${namespace}/CREATE_PROPERTY_OFFER_AGG_START`;
export const CREATE_PROPERTY_OFFER_AGG_SUCCESS = `${namespace}/CREATE_PROPERTY_OFFER_AGG_SUCCESS`;
export const CREATE_PROPERTY_OFFER_AGG_ERROR = `${namespace}/CREATE_PROPERTY_OFFER_AGG_ERROR`;

export const createPropertyOfferAgg = makeApiActionCreatorV3(
  api.createPropertyOfferAgg,
  CREATE_PROPERTY_OFFER_AGG_START,
  CREATE_PROPERTY_OFFER_AGG_SUCCESS,
  CREATE_PROPERTY_OFFER_AGG_ERROR,
);

export const UPDATE_FINAL_VALUE_START = `${namespace}/UPDATE_FINAL_VALUE_START`;
export const UPDATE_FINAL_VALUE_SUCCESS = `${namespace}/UPDATE_FINAL_VALUE_SUCCESS`;
export const UPDATE_FINAL_VALUE_ERROR = `${namespace}/UPDATE_FINAL_VALUE_ERROR`;

export const updateFinalValue = makeApiActionCreatorV3(
  api.updateFinalValue,
  UPDATE_FINAL_VALUE_START,
  UPDATE_FINAL_VALUE_SUCCESS,
  UPDATE_FINAL_VALUE_ERROR,
);

export const UPDATE_PROPERTY_OFFER_IND_START = `${namespace}/UPDATE_PROPERTY_OFFER_IND_START`;
export const UPDATE_PROPERTY_OFFER_IND_SUCCESS = `${namespace}/UPDATE_PROPERTY_OFFER_IND_SUCCESS`;
export const UPDATE_PROPERTY_OFFER_IND_ERROR = `${namespace}/UPDATE_PROPERTY_OFFER_IND_ERROR`;

export const updatePropertyOfferInd = makeApiActionCreatorV3(
  api.updatePropertyOfferInd,
  UPDATE_PROPERTY_OFFER_IND_START,
  UPDATE_PROPERTY_OFFER_IND_SUCCESS,
  UPDATE_PROPERTY_OFFER_IND_ERROR,
);

export const PUBLISH_PROPERTY_OFFER_IND_START = `${namespace}/PUBLISH_PROPERTY_OFFER_IND_START`;
export const PUBLISH_PROPERTY_OFFER_IND_SUCCESS = `${namespace}/PUBLISH_PROPERTY_OFFER_IND_SUCCESS`;
export const PUBLISH_PROPERTY_OFFER_IND_ERROR = `${namespace}/PUBLISH_PROPERTY_OFFER_IND_ERROR`;

export const publishPropertyOfferInd = makeApiActionCreatorV3(
  api.publishPropertyOfferInd,
  PUBLISH_PROPERTY_OFFER_IND_START,
  PUBLISH_PROPERTY_OFFER_IND_SUCCESS,
  PUBLISH_PROPERTY_OFFER_IND_ERROR,
);

export const UPDATE_PROPERTY_OFFER_AGG_START = `${namespace}/UPDATE_PROPERTY_OFFER_AGG_START`;
export const UPDATE_PROPERTY_OFFER_AGG_SUCCESS = `${namespace}/UPDATE_PROPERTY_OFFER_AGG_SUCCESS`;
export const UPDATE_PROPERTY_OFFER_AGG_ERROR = `${namespace}/UPDATE_PROPERTY_OFFER_AGG_ERROR`;

export const updatePropertyOfferAgg = makeApiActionCreatorV3(
  api.updatePropertyOfferAgg,
  UPDATE_PROPERTY_OFFER_AGG_START,
  UPDATE_PROPERTY_OFFER_AGG_SUCCESS,
  UPDATE_PROPERTY_OFFER_AGG_ERROR,
);

export const FETCH_CASE_OFFER_ACTIVITY_START = `${namespace}/FETCH_CASE_OFFER_ACTIVITY_START`;
export const FETCH_CASE_OFFER_ACTIVITY_SUCCESS = `${namespace}/FETCH_CASE_OFFER_ACTIVITY_SUCCESS`;
export const FETCH_CASE_OFFER_ACTIVITY_ERROR = `${namespace}/FETCH_CASE_OFFER_ACTIVITY_ERROR`;

export const fetchCaseOfferActivity = makeApiActionCreatorV3(
  api.fetchCaseOfferActivity,
  FETCH_CASE_OFFER_ACTIVITY_START,
  FETCH_CASE_OFFER_ACTIVITY_SUCCESS,
  FETCH_CASE_OFFER_ACTIVITY_ERROR,
);

export const REOPEN_PROPERTY_OFFERS_START = `${namespace}/REOPEN_PROPERTY_OFFERS_START`;
export const REOPEN_PROPERTY_OFFERS_SUCCESS = `${namespace}/REOPEN_PROPERTY_OFFERS_SUCCESS`;
export const REOPEN_PROPERTY_OFFERS_ERROR = `${namespace}/REOPEN_PROPERTY_OFFERS_ERROR`;

export const reopenPropertyOffers = makeApiActionCreatorV3(
  api.reopenPropertyOffers,
  REOPEN_PROPERTY_OFFERS_START,
  REOPEN_PROPERTY_OFFERS_SUCCESS,
  REOPEN_PROPERTY_OFFERS_ERROR,
);

export const WITHDRAW_PROPERTY_OFFERS_START = `${namespace}/WITHDRAW_PROPERTY_OFFERS_START`;
export const WITHDRAW_PROPERTY_OFFERS_SUCCESS = `${namespace}/WITHDRAW_PROPERTY_OFFERS_SUCCESS`;
export const WITHDRAW_PROPERTY_OFFERS_ERROR = `${namespace}/WITHDRAW_PROPERTY_OFFERS_ERROR`;

export const withdrawPropertyOffers = makeApiActionCreatorV3(
  api.withdrawPropertyOffers,
  WITHDRAW_PROPERTY_OFFERS_START,
  WITHDRAW_PROPERTY_OFFERS_SUCCESS,
  WITHDRAW_PROPERTY_OFFERS_ERROR,
);

export const CANCEL_PROPERTY_OFFERS_START = `${namespace}/CANCEL_PROPERTY_OFFERS_START`;
export const CANCEL_PROPERTY_OFFERS_SUCCESS = `${namespace}/CANCEL_PROPERTY_OFFERS_SUCCESS`;
export const CANCEL_PROPERTY_OFFERS_ERROR = `${namespace}/CANCEL_PROPERTY_OFFERS_ERROR`;

export const cancelPropertyOffers = makeApiActionCreatorV3(
  api.cancelPropertyOffers,
  CANCEL_PROPERTY_OFFERS_START,
  CANCEL_PROPERTY_OFFERS_SUCCESS,
  CANCEL_PROPERTY_OFFERS_ERROR,
);

export const PUBLISH_PROPERTY_OFFERS_START = `${namespace}/PUBLISH_PROPERTY_OFFERS_START`;
export const PUBLISH_PROPERTY_OFFERS_SUCCESS = `${namespace}/PUBLISH_PROPERTY_OFFERS_SUCCESS`;
export const PUBLISH_PROPERTY_OFFERS_ERROR = `${namespace}/PUBLISH_PROPERTY_OFFERS_ERROR`;

export const publishPropertyOffers = makeApiActionCreatorV3(
  api.publishPropertyOffers,
  PUBLISH_PROPERTY_OFFERS_START,
  PUBLISH_PROPERTY_OFFERS_SUCCESS,
  PUBLISH_PROPERTY_OFFERS_ERROR,
);

export const ACCEPT_PROPERTY_OFFERS_START = `${namespace}/ACCEPT_PROPERTY_OFFERS_START`;
export const ACCEPT_PROPERTY_OFFERS_SUCCESS = `${namespace}/ACCEPT_PROPERTY_OFFERS_SUCCESS`;
export const ACCEPT_PROPERTY_OFFERS_ERROR = `${namespace}/ACCEPT_PROPERTY_OFFERS_ERROR`;

export const acceptPropertyOffers = makeApiActionCreatorV3(
  api.acceptPropertyOffers,
  ACCEPT_PROPERTY_OFFERS_START,
  ACCEPT_PROPERTY_OFFERS_SUCCESS,
  ACCEPT_PROPERTY_OFFERS_ERROR,
);

export const REJECT_PROPERTY_OFFERS_START = `${namespace}/REJECT_PROPERTY_OFFERS_START`;
export const REJECT_PROPERTY_OFFERS_SUCCESS = `${namespace}/REJECT_PROPERTY_OFFERS_SUCCESS`;
export const REJECT_PROPERTY_OFFERS_ERROR = `${namespace}/REJECT_PROPERTY_OFFERS_ERROR`;

export const rejectPropertyOffers = makeApiActionCreatorV3(
  api.rejectPropertyOffers,
  REJECT_PROPERTY_OFFERS_START,
  REJECT_PROPERTY_OFFERS_SUCCESS,
  REJECT_PROPERTY_OFFERS_ERROR,
);

export const FETCH_OFFER_START = `${namespace}/FETCH_OFFER_START`;
export const FETCH_OFFER_SUCCESS = `${namespace}/FETCH_OFFER_SUCCESS`;
export const FETCH_OFFER_ERROR = `${namespace}/FETCH_OFFER_ERROR`;

export const fetchOffer = makeApiActionCreatorV3(
  api.fetchOffer,
  FETCH_OFFER_START,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFER_ERROR,
);

export const FETCH_OFFERS_START = `${namespace}/FETCH_OFFERS_START`;
export const FETCH_OFFERS_SUCCESS = `${namespace}/FETCH_OFFERS_SUCCESS`;
export const FETCH_OFFERS_ERROR = `${namespace}/FETCH_OFFERS_ERROR`;

export const fetchOffers = makeApiActionCreatorV3(
  api.fetchOffers,
  FETCH_OFFERS_START,
  FETCH_OFFERS_SUCCESS,
  FETCH_OFFERS_ERROR,
);

export const FETCH_OFFER_FILE_START = `${namespace}/FETCH_OFFER_FILE_START`;
export const FETCH_OFFER_FILE_SUCCESS = `${namespace}/FETCH_OFFER_FILE_SUCCESS`;
export const FETCH_OFFER_FILE_ERROR = `${namespace}/FETCH_OFFER_FILE_ERROR`;

export const fetchOfferFile = makeApiActionCreatorV3(
  api.fetchOfferFile,
  FETCH_OFFER_FILE_START,
  FETCH_OFFER_FILE_SUCCESS,
  FETCH_OFFER_FILE_ERROR,
);

export const FETCH_OFFER_FILES_START = `${namespace}/FETCH_OFFER_FILES_START`;
export const FETCH_OFFER_FILES_SUCCESS = `${namespace}/FETCH_OFFER_FILES_SUCCESS`;
export const FETCH_OFFER_FILES_ERROR = `${namespace}/FETCH_OFFER_FILES_ERROR`;

export const fetchOfferFiles = makeApiActionCreatorV3(
  api.fetchOfferFiles,
  FETCH_OFFER_FILES_START,
  FETCH_OFFER_FILES_SUCCESS,
  FETCH_OFFER_FILES_ERROR,
);

export const FETCH_CODEFILE_FILING_PARTY_START = `${namespace}/FETCH_CODEFILE_FILING_PARTY_START`;
export const FETCH_CODEFILE_FILING_PARTY_SUCCESS = `${namespace}/FETCH_CODEFILE_FILING_PARTY_SUCCESS`;
export const FETCH_CODEFILE_FILING_PARTY_ERROR = `${namespace}/FETCH_CODEFILE_FILING_PARTY_ERROR`;

export const fetchCodefileFilingParty = makeApiActionCreatorV3(
  api.fetchCodefileFilingParty,
  FETCH_CODEFILE_FILING_PARTY_START,
  FETCH_CODEFILE_FILING_PARTY_SUCCESS,
  FETCH_CODEFILE_FILING_PARTY_ERROR,
);

export const FETCH_CODEFILE_OFFER_STATUS_START = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_START`;
export const FETCH_CODEFILE_OFFER_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_SUCCESS`;
export const FETCH_CODEFILE_OFFER_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_ERROR`;

export const fetchCodefileOfferStatus = makeApiActionCreatorV3(
  api.fetchCodefileOfferStatus,
  FETCH_CODEFILE_OFFER_STATUS_START,
  FETCH_CODEFILE_OFFER_STATUS_SUCCESS,
  FETCH_CODEFILE_OFFER_STATUS_ERROR,
);

export const FETCH_CODEFILE_OFFER_TYPE_START = `${namespace}/FETCH_CODEFILE_OFFER_TYPE_START`;
export const FETCH_CODEFILE_OFFER_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_OFFER_TYPE_SUCCESS`;
export const FETCH_CODEFILE_OFFER_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_OFFER_TYPE_ERROR`;

export const fetchCodefileOfferType = makeApiActionCreatorV3(
  api.fetchCodefileOfferType,
  FETCH_CODEFILE_OFFER_TYPE_START,
  FETCH_CODEFILE_OFFER_TYPE_SUCCESS,
  FETCH_CODEFILE_OFFER_TYPE_ERROR,
);

export const INSERT_OFFER_START = `${namespace}/INSERT_OFFER_START`;
export const INSERT_OFFER_SUCCESS = `${namespace}/INSERT_OFFER_SUCCESS`;
export const INSERT_OFFER_ERROR = `${namespace}/INSERT_OFFER_ERROR`;

export const insertOffer = makeApiActionCreatorV3(
  api.insertOffer,
  INSERT_OFFER_START,
  INSERT_OFFER_SUCCESS,
  INSERT_OFFER_ERROR,
);

export const INSERT_OFFER_FILE_START = `${namespace}/INSERT_OFFER_FILE_START`;
export const INSERT_OFFER_FILE_SUCCESS = `${namespace}/INSERT_OFFER_FILE_SUCCESS`;
export const INSERT_OFFER_FILE_ERROR = `${namespace}/INSERT_OFFER_FILE_ERROR`;

export const insertOfferFile = makeApiActionCreatorV3(
  api.insertOfferFile,
  INSERT_OFFER_FILE_START,
  INSERT_OFFER_FILE_SUCCESS,
  INSERT_OFFER_FILE_ERROR,
);

export const UPDATE_OFFER_START = `${namespace}/UPDATE_OFFER_START`;
export const UPDATE_OFFER_SUCCESS = `${namespace}/UPDATE_OFFER_SUCCESS`;
export const UPDATE_OFFER_ERROR = `${namespace}/UPDATE_OFFER_ERROR`;

export const updateOffer = makeApiActionCreatorV3(
  api.updateOffer,
  UPDATE_OFFER_START,
  UPDATE_OFFER_SUCCESS,
  UPDATE_OFFER_ERROR,
);

export const UPDATE_OFFER_TAGS_START = `${namespace}/UPDATE_OFFER_TAGS_START`;
export const UPDATE_OFFER_TAGS_SUCCESS = `${namespace}/UPDATE_OFFER_TAGS_SUCCESS`;
export const UPDATE_OFFER_TAGS_ERROR = `${namespace}/UPDATE_OFFER_TAGS_ERROR`;

export const updateOfferTags = makeApiActionCreatorV3(
  api.updateOfferTags,
  UPDATE_OFFER_TAGS_START,
  UPDATE_OFFER_TAGS_SUCCESS,
  UPDATE_OFFER_TAGS_ERROR,
);

export const UPDATE_OFFER_FILE_START = `${namespace}/UPDATE_OFFER_FILE_START`;
export const UPDATE_OFFER_FILE_SUCCESS = `${namespace}/UPDATE_OFFER_FILE_SUCCESS`;
export const UPDATE_OFFER_FILE_ERROR = `${namespace}/UPDATE_OFFER_FILE_ERROR`;

export const updateOfferFile = makeApiActionCreatorV3(
  api.updateOfferFile,
  UPDATE_OFFER_FILE_START,
  UPDATE_OFFER_FILE_SUCCESS,
  UPDATE_OFFER_FILE_ERROR,
);

export const DELETE_OFFER_START = `${namespace}/DELETE_OFFER_START`;
export const DELETE_OFFER_SUCCESS = `${namespace}/DELETE_OFFER_SUCCESS`;
export const DELETE_OFFER_ERROR = `${namespace}/DELETE_OFFER_ERROR`;

export const deleteOffer = makeApiActionCreatorV3(
  api.deleteOffer,
  DELETE_OFFER_START,
  DELETE_OFFER_SUCCESS,
  DELETE_OFFER_ERROR,
);

export const DELETE_OFFER_FILE_START = `${namespace}/DELETE_OFFER_FILE_START`;
export const DELETE_OFFER_FILE_SUCCESS = `${namespace}/DELETE_OFFER_FILE_SUCCESS`;
export const DELETE_OFFER_FILE_ERROR = `${namespace}/DELETE_OFFER_FILE_ERROR`;

export const deleteOfferFile = makeApiActionCreatorV3(
  api.deleteOfferFile,
  DELETE_OFFER_FILE_START,
  DELETE_OFFER_FILE_SUCCESS,
  DELETE_OFFER_FILE_ERROR,
);

export const DOWNLOAD_OFFER_FILE_START = `${namespace}/DOWNLOAD_OFFER_FILE_START`;
export const DOWNLOAD_OFFER_FILE_SUCCESS = `${namespace}/DOWNLOAD_OFFER_FILE_SUCCESS`;
export const DOWNLOAD_OFFER_FILE_ERROR = `${namespace}/DOWNLOAD_OFFER_FILE_ERROR`;

export const downloadOfferFile = makeApiActionCreatorV3(
  api.downloadOfferFile,
  DOWNLOAD_OFFER_FILE_START,
  DOWNLOAD_OFFER_FILE_SUCCESS,
  DOWNLOAD_OFFER_FILE_ERROR,
);
